import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'app-fullscreen-photo',
    templateUrl: './fullscreen-photo.component.html',
    styleUrls: ['./fullscreen-photo.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FullscreenPhotoComponent {
    @Input() photo!: string;

    private rotation = 0;

    transform?: string;

    constructor(
        private modalController: ModalController
    ) {}

    onRotateLeft(): void {
        this.rotation -= 90;
        this.setTransform();
    }

    onRotateRight(): void {
        this.rotation += 90;
        this.setTransform();
    }

    onClose(): void {
        this.modalController.dismiss();
    }

    private setTransform(): void {
        this.transform = `scale(1) rotate(${this.rotation}deg)`;
    }
}
